import { Maybe } from "./Maybe"
import { RJSFFormData } from "./RJSF"

export const ProductConfigurationAPIType = "product_configurations" as const
export const ProductConfigurationModelsAPIType = "models" as const
export const ProductConfigurationProductsAPIType = "products" as const
export const ProductConfigurationAddonsAPIType = "addons" as const
export const ProductConfigurationMetaAPIType = "meta" as const
export const ProductConfigurationDimensioningAPIType = "dimensionings" as const
export const ProductConfigurationSpecialAttributesAPIType =
  "special_attributes" as const

export interface ProductConfigurationFormData extends RJSFFormData {
  value?: boolean
  product?: Maybe<RJSFFormData>
  addons?: Maybe<{ [x: string]: ProductConfigurationFormData }>
}

export enum ProductConfiguratorStepType {
  LOADING = "LOADING",
  DIMENSIONING = "DIMENSIONING",
  CONFIGURATION = "CONFIGURATION",
  ADDONS = "ADDONS",
  SUMMARY = "SUMMARY"
}
